import { BrowserRouter } from "react-router-dom";
import { AuthProvider }  from "@context/AuthContext";
import { ThemeProvider } from "@context/ThemeContext";
import AppRoutes         from "@routes/AppRoutes";
import "@styles/global.css";

export default function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}
